import React, { useEffect, useState } from 'react';

import { Col, Row } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { paymentStep, paymentVerify, setPaymentSlug } from '../../redux/payment/actions';
import Loader from '../../components/loader/Loader';
// import paymentSuccess from '../../assets/payment-success.svg';
import paymentSuccess from '../../assets/payment-success.svg';
import paymentFailed from '../../assets/payment-failed.svg';
import logo from '../../assets/logo.svg';
import Footer from '../../components/footer/Footer';
import LanguageDropdown from '../../components/Language-Dropdown/LanguageDropdown';

export default function VerifyAlmaOnboardingStatus() {
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);

  const loaderStatus = useSelector((state) => state.loader.pageLoader);
  const paymentStepCount = useSelector((state) => state.payment.paymentStep);
  const paymentStatus = useSelector((state) => state.payment.paymentStatus);
  const paymentSlug = useSelector((state) => state?.payment?.paymentSlug);

  const language = useSelector((state) => state?.auth?.language);


  const [searchParams] = useSearchParams(); // Get query params
  const id = searchParams.get('id');

  useEffect(() => {
    if (id) {
      dispatch(paymentVerify(id));
    }
  }, []);
  useEffect(() => {
    setStep(paymentStepCount);
  }, [paymentStepCount]);
  useEffect(() => {
    setStep(paymentStepCount);
  }, [paymentStepCount]);

  const handleRedirect = (e) => {
    e.preventDefault();
    if (paymentStatus) {
      window.location.href = `/pay/${paymentSlug}`;
      dispatch(paymentStep(1));
      dispatch(setPaymentSlug(''));
    }
  };

  return (
    <>
      {loaderStatus && <Loader />}
      <div className="main_section h-full bg_icon bg-mobile-view">
        <div className="container px-only-md-2 box-alignment">
          <div className="w-100 pt-3 mb-3" style={{ zIndex: '9992' }}>
            <Row gutter={[16, 16]}>
              <Col xs={0} md={4} style={{ padding: '0px', margin: '0px' }} />
              <Col xs={12} md={15}>
                <div className="text-md-center logo-size">
                  <img src={logo} alt="logo" width={245} height={60} />
                </div>
              </Col>
              <Col xs={12} md={5} className="btn-hide-hove">
                <LanguageDropdown />
              </Col>
            </Row>
          </div>

          {!loaderStatus && step === 3 && (
            <Row gutter={[16, 16]}>
              <Col xs={24} md={8} lg={6} className="align-self-center mx-auto text-center">
                <div className="mx-auto">
                  {paymentStatus ? (
                    <>
                      <img src={paymentSuccess} alt="paymentSuccess img" className="img-fluid" />
                      <div className="color-success payment-status-text">{language?.content?.PAYMENT_SUCCESS}</div>
                    </>
                  ) : (
                    <>
                      <img src={paymentFailed} alt="paymentFailed img" className="img-fluid" />
                      <div className="color-danger payment-status-text">{language?.content?.PAYMENT_FAIL}</div>
                    </>
                  )}
                </div>
                <div className="pt-3">
                  <div
                    style={{ fontSize: '16px', color: '#007DFC', fontWeight: '600', cursor: 'pointer' }}
                    role="button"
                    tabIndex={0}
                    onClick={handleRedirect}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        handleRedirect(e);
                      }
                    }}
                  >
                    {language?.content?.BACK_TO_HOME || 'Back to home'}
                  </div>

                  {/* <a href={`/pay/${id}`} style={{ fontSize: '16px', color: '#007DFC', fontWeight: '600' }}>
                    {language?.content?.BACK_TO_HOME || 'Back to home'}
                  </a> */}
                </div>
              </Col>
            </Row>
          )}
          <div className="py-2" style={{ marginLeft: '-8px', marginRight: '-8px' }}>
            <Footer language={language} />
          </div>
        </div>
      </div>
    </>
  );
}
